export enum ContentType {
    POST = "post",
    COMMENT = "comment",
}

export type Content = {
    commentCount: number;
    content: string;
    contentType: ContentType;
    createdAt: string;
    displayDate: string;
    id: number;
    parentContent: string | null;
    parentId: number;
    reactionCount: Record<string, number>;
    user: {
        activeState: string;
        allowToContact: boolean;
        avatar: string | null;
        gender: string;
        isActive: boolean;
        role: string;
        screenName: string;
        uuid: string;
    };
    ranking?: number;
};

export type ContentListItemType = {
    content: Content;
    onItemClick: (content: Content) => void;
    stringsToHighlight?: string[];
};
